<template>
    <el-dialog class="dialog" v-if="outerForm" :visible.sync="outerForm" :title="dialogType==='edit'?'编辑需求' : '创建需求'" width="1200px" top="5vh" >
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <el-form class="flex-form" ref="postForm" :model="postForm" :rules="postRules" label-width="100px"  >
                <div class="all title" v-if="dialogType =='edit'">需求信息</div>
                <el-form-item label="所属产品：" prop="systemType" >
                    <el-select v-model="postForm.systemType" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="dialogType =='edit'? true : false" @change="handleProduct" style="width: 220px;">
                        <el-option v-for="item in productOption" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="所属游戏：" prop="appkey" v-if="postForm.systemType !== 'file'">
                    <el-select v-model="postForm.appkey" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="!postForm.systemType || dialogType =='edit'? true : false" @change="handleGame" style="width: 220px;">
                        <el-option v-for="item in gameKeyOption" :key="item.appkey" :label="item.productName" :value="item.appkey"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="所属菜单：" prop="menuId" v-if="postForm.systemType !== 'file'">
                    <!-- <el-select v-model="postForm.menuId" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="!postForm.appkey || dialogType =='edit'? true : false" @change="handleMenu" style="width: 200px;">
                        <el-option v-for="item in menuOption" :key="item.meta.id" :label="item.meta.title" :value="item.meta.id"></el-option>
                    </el-select> -->
                    <el-cascader ref="menus" v-model="postForm.menuId" size="small" :props="{ expandTrigger: 'hover' }" :options="menuOption" clearable :disabled="!postForm.appkey || dialogType =='edit'? true : false" @change="handleMenu" style="width: 220px;"></el-cascader>
                </el-form-item>

                <el-form-item label="所属模块：" prop="code" v-if="postForm.systemType !== 'file'">
                    <el-select ref="code" v-model="postForm.code" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="!postForm.menuId || dialogType =='edit'? true : false" style="width: 220px;">
                        <el-option v-for="item in codeOption" :key="item.id" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="需求类型：" prop="type">
                    <el-select v-model="postForm.type" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="dialogType =='edit'? true : false" style="width: 220px;">
                        <el-option v-for="item in typeOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="优先级：" prop="level">
                    <el-select v-model="postForm.level" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="dialogType =='edit'? true : false" style="width: 220px;">
                        <el-option v-for="item in levelOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-popover placement="right" width="300" trigger="hover">
                        <span>优先级标识需求的重要性，P1表示重要，P2表示次重要，P3表示不重要</span>
                        <i slot="reference" style="cursor: pointer;" class="el-icon-question" />
                    </el-popover>
                </el-form-item>

                <el-form-item label="标题：" prop="title">
                    <el-input v-model="postForm.title" size="small" placeholder="请输入内容" style="width: 220px;" :disabled="dialogType =='edit'? true : false"></el-input>
                </el-form-item>

                <el-form-item label="描述：" :prop="source == 'userDemand' ? 'describe' : ''" class="all" >
                    <!-- <el-input v-model="postForm.product" placeholder="请输入内容" :disabled="dialogType =='edit'? true : false"></el-input> -->
                    <markdown-editor ref="markdownEditor" v-model="postForm.describe" mode="wysiwyg" :disabled="dialogType =='edit'? true : false" language="zh-CN" height="500px" @input="handleDescribe($event, 'describe')" />
                </el-form-item>

                <el-form-item label="备注：" :prop="source == 'userDemand' ? 'desc' : ''" class="all" v-if="dialogType =='edit'">
                    <markdown-editor v-model="postForm.desc" mode="wysiwyg" language="zh-CN" :disabled="source == 'myDemand'? true : false" height="500px"  @input="handleDescribe($event, 'desc')" />
                </el-form-item>

                <template v-if="dialogType =='edit'">
                    <div class="all title">需求反馈</div>
                    <el-form-item label="需求进度：" :prop="source == 'myDemand' ? 'status' : ''" >
                        <el-select v-model="postForm.status" size="small" placeholder="请选择" class="filter-item" filterable clearable :disabled="source == 'userDemand'? true : false" style="width: 200px;">
                            <el-option v-for="item in statusOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="反馈意见：" prop="feedback" class="all">
                        <markdown-editor v-model="postForm.feedback" mode="wysiwyg" language="zh-CN" :disabled="source == 'userDemand'? true : false"  height="500px" />
                    </el-form-item>
                </template>
            </el-form>
        </el-scrollbar>
         <!-- 按钮组 -->
        <div class="dialog-butn-box">
            <el-button type="primary" @click="handleSave">确认</el-button>
            <el-button @click="outerForm=false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import { ajax_game, ajax_menu, ajax_codeView, ajax_demand, ajax_demandDetail} from '@Demand~/api/demand'
// 弹窗默认的数据内容
const defaultFrom = {
  systemType: '', // 所属平台
  appkey:'', // 游戏
  menuId: '', //菜单
  code: '', // 模块
  type: '', // 需求类型
  title: '', // 标题
  level: '', // 优先级
}

export default {
    props: {
        source:{
            type: String,
            default: '',
            required: true
        }
    },
    components: {MarkdownEditor},
    data() {
        return {
            outerForm: false,
            dialogType: 'add',
            postForm:{},
            postRules: {
                systemType:[{required: true, trigger: ['blur', 'change'], message: '请选择所属产品'}],
                appkey:[{required: true, trigger: ['blur', 'change'], message: '请选择所属游戏'}],
                menuId:[{required: true, trigger: ['blur', 'change'], message: '请选择所属菜单'}],
                code:[{required: true, trigger: ['blur', 'change'], message: '请选择所属模块'}],
                type:[{required: true, trigger: ['blur', 'change'], message: '请选择需求类型'}],
                title:[{required: true, trigger: ['blur', 'change'], message: '请填写需求标题'}],
                level:[{required: true, trigger: ['blur', 'change'], message: '请选择优先级'}],
                describe:[{required: true, trigger: ['blur', 'change'], message: '请填写需求描述'}],
                desc: [{required: true, trigger: ['blur', 'change'], message: '请填写需求备注'}],
                status: [{required: true, trigger: ['blur', 'change'], message: '请选择需求进度'}],
                // feedback:[{required: true, trigger: ['blur', 'change'], message: '请填写需求描述'}]
            },
            productOption:[{value: 'bdc', name:'BDC4.0'},{value: 'ads', name:'广告投放'},{value: 'adt', name:'广告监控'},{value: 'adx', name:'广告增值'},{value: 'gms', name:'GMS客服'},{value: 'file', name:'美术平台'}],
            typeOption:[{id:1,name:'数据异常'},{id:2,name:'产品优化'},{id:3,name:'功能BUG'},{id:4,name:'平台异常'},{id:0,name:'其他'}],
            levelOption:[{id:1,name:'P1'},{id:2,name:'P2'},{id:3,name:'P3'}],
            statusOption:[{id:0,name:'评估中'},{id:1,name:'已规划'},{id:2,name:'开发中'},{id:3,name:'已发布'},{id:4,name:'已关闭'}],
            gameKeyOption:[], // 游戏列表
            menuOption:[], // 菜单列表
            codeOption:[], // 模块列表
        }
    },
    methods: {
        // 初始化添加弹窗
        addInit() {
            this.outerForm = true
            this.dialogType = 'add'
            this.postForm = JSON.parse(JSON.stringify(defaultFrom))
            this.gameKeyOption = []
            this.menuOption = []
            this.codeOption = []
            this.$nextTick(() => {
                this.$refs['postForm'].clearValidate()
            })
        },

        // 初始化编辑弹窗
        editInit(item) {
            this.outerForm = true
            this.dialogType = 'edit'
            this.getDetail(item.id) // 编辑时查询详情接口
            this.$nextTick(() => {
                this.$refs['postForm'].clearValidate()
            })

            console.log('====编辑')
        },

        // 编辑时查询详情接口
        getDetail(id) {
            ajax_demandDetail(id).then(response => {
                if(response.code == 1) {
                    this.postForm = JSON.parse(JSON.stringify(response.data))
                    
                    if(this.postForm.systemType != 'file') {
                        this.postForm.menuId = response.data.menuId.split(',')
                        this.$nextTick(() => {
                            this.getGameKeys()
                            this.getMenu()
                            this.getCode()
                        })
                    }   
                }
            })
        },

        // 确认
        handleSave() {
            this.$refs['postForm'].validate((valid) => {
                if (valid) {
                    let gameKey = ''
                    if(this.postForm.systemType == 'bdc' || this.postForm.systemType == 'gms') {
                        this.gameKeyOption.forEach(item => {
                            if(item.appkey == this.postForm.appkey) {
                                gameKey = item.gameKey
                            }
                        })
                    }
                    const data = {
                        appkey: this.postForm.systemType == 'file' ? '' : this.postForm.appkey,
                        gameKey: gameKey,
                        level: this.postForm.level,
                        systemType: this.postForm.systemType,
                        menuId: this.postForm.systemType == 'file' ? '' : this.postForm.menuId.join(','),
                        menuName: this.postForm.systemType == 'file' ? '' : this.$refs.menus.getCheckedNodes()[0].pathLabels.join(','),
                        code: this.postForm.systemType == 'file' ? '' : this.postForm.code,
                        kpiName: this.postForm.systemType == 'file' ? '' : this.$refs['code'].$data.selectedLabel,
                        title: this.postForm.title,
                        type: this.postForm.type,
                        status: this.postForm.status,
                        userId: this.$store.getters.userId,
                        userName: this.$store.getters.realName,
                        describe: this.postForm.describe,

                        id:  this.dialogType == 'edit' ? this.postForm.id : '',
                        desc: this.dialogType == 'edit' ? this.postForm.desc : '',

                        feedback: this.dialogType == 'edit' && this.source == 'myDemand' ? this.postForm.feedback : '',
                        completeUserId: this.dialogType == 'edit' && this.source == 'myDemand' ? this.$store.getters.userId : '',
                        completeUserName: this.dialogType == 'edit' && this.source == 'myDemand' ? this.$store.getters.realName : '',
                    }

                   // console.log(data)
                    ajax_demand(data).then(response => {
                        if(response.code == 1) {
                            this.outerForm = false // 关闭弹窗
                            this.$message({
                                message: this.dialogType =='edit' ? '编辑成功' : '创建成功',
                                type: 'success'
                            });

                           this.$emit('renewList') // 重新获取列表
                        }
                    })
                }
            })
        },

        // 监听需求描述
        handleDescribe(val, prop) {
            if(val) {
                this.$refs['postForm'].clearValidate(prop)
            }
        },

        // 监听产品
        handleProduct() {   
            this.postForm.appkey = ''
            this.gameKeyOption = []
            this.getGameKeys() // 获取所属游戏
        },

        // 监听游戏
        handleGame() {
            this.postForm.menuId = ''
            this.menuOption = []
            this.getMenu()  // 获取所属菜单
        },

        // 监听菜单
        handleMenu() {
            this.postForm.code = ''
            this.codeOption = []
            this.getCode() // 获取所属模块
            // console.log(this.postForm.menuId.join(','), this.$refs.menus.getCheckedNodes()[0].pathLabels.join(','))
        },

        // 获取所属游戏
        getGameKeys() {
            ajax_game(this.postForm.systemType).then(response => {
                if(response.code == 1) {
                    this.gameKeyOption = response.data
                }
            })
        },

        // 获取所属菜单
        getMenu() {
            const isAll = this.postForm.appkey == 'all' ? true : false
            ajax_menu(this.postForm.systemType, this.postForm.appkey, isAll).then(response => {
                if(response.code == 1) {
                    this.menuOption = this.transformMenu(response.data)
                }
            })
        },

        // 转换菜单数据
        transformMenu(list) {
            return list.map(v => {
                if(v.children && v.children.length == 0) {
                    v.children = null
                }

                if(v.children && v.children.length > 0) {
                    this.transformMenu(v.children)
                }
                return v
            })
        },

        // 获取所属模块
        getCode() {
            const data = {
               menuId: this.postForm.menuId[this.postForm.menuId.length-1],
               isAll: true
            }
            ajax_codeView(data).then(response => {
                if(response.code == 1) {
                    this.codeOption = response.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .flex-form{
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;

        .el-form-item{
            min-width: 30%;
        }

        .all{
            min-width: 98%;
        }
    }
    .title{
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid #d6d6d6;
        padding: 10px;
        margin-bottom: 20px;
    }
    .dialog ::v-deep .el-dialog__body{
        height: 760px;
        padding: 0 20px 50px;
        overflow: hidden;

        .scrollbar-wrapper {
            overflow-x: hidden !important;
        }

        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }

        .el-scrollbar {
            height: 100%;
        }
    }
    
</style>
